<template>
  <div>
    <div class="week_record_box">
      <div class="week_record_title">写手周结登记</div>
      <el-date-picker
        v-model="timeData"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        size="mini"
        @change="timeChange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
    </div>

    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="90px"
      >
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="写手昵称" prop="writer_nickname">
          <el-input v-model="filter_form.writer_nickname"></el-input>
        </el-form-item>
        <el-form-item label="写手姓名" prop="writer_name">
          <el-input v-model="filter_form.writer_name"></el-input>
        </el-form-item>
        <el-form-item label="写手支付宝" prop="alipay_account">
          <el-input v-model="filter_form.alipay_account"></el-input>
        </el-form-item>

        <el-form-item label="结算状态" prop="is_settle">
          <el-select v-model="filter_form.is_settle" placeholder="结算状态  ">
            <el-option label="全部" value=""></el-option>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table height="550" :data="weekRecordList" border>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>

        <el-table-column
          property="writer_nickname"
          label="写手昵称"
          align="center"
          sortable
          width="101"
        ></el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          sortable
          width="80"
        ></el-table-column>
        <el-table-column
          property="writer_name"
          label="写手姓名"
          align="center"
          sortable
          width="101"
        ></el-table-column>
        <el-table-column
          property="alipay_account"
          label="写手支付宝"
          align="center"
          sortable
          width="115"
        ></el-table-column>
        <el-table-column
          property="start_chapters"
          label="开始章节"
          align="center"
          sortable
          width="101"
        ></el-table-column>
        <el-table-column
          property="end_chapters"
          label="结束章节"
          align="center"
          sortable
          width="101"
        ></el-table-column>
        <el-table-column
          property="word_number"
          label="入库字数"
          align="center"
          sortable
          width="101"
        >
        </el-table-column>
        <el-table-column
          property="writer_cost"
          label="给写手的千字价格"
          align="center"
          sortable
          width="157"
        >
        </el-table-column>

        <el-table-column
          property="each_chapter_num"
          label="每章字数"
          align="center"
          sortable
          width="101"
        >
        </el-table-column>
        <el-table-column
          property="manuscript_diff"
          label="差价"
          align="center"
          sortable
          width="80"
        >
        </el-table-column>
        <el-table-column
          property="fee"
          label="实际应收稿费"
          align="center"
          sortable
          width="135"
        >
        </el-table-column>
        <el-table-column
          property="sj_fee"
          label="实际应发稿费"
          align="center"
          sortable
          width="135"
        >
        </el-table-column>
        <el-table-column
          property="deposit_money"
          label="压稿金额"
          align="center"
          sortable
          width="110"
        >
        </el-table-column>
        <el-table-column
          property="advance_fee"
          label="预支金额"
          align="center"
          sortable
          width="110"
        >
        </el-table-column>
        <el-table-column
          property="settlement_type"
          label="日周结"
          align="center"
          sortable
          width="90"
        >
          <template slot-scope="scope">
            <el-tag :class="scope.row.settlement_type == '1' ? 'day' : 'week'">
              {{ scope.row.settlement_type == "1" ? "日结" : "周结" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="is_settle"
          label="周结状态"
          align="center"
          sortable
          width="110"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_settle == '0' ? 'danger' : 'success'">
              {{ scope.row.is_settle == "0" ? "未结算" : "已结清" }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          property="status"
          label="是否通过"
          align="center"
          sortable
          width="110"
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.status == '0'
                  ? ''
                  : scope.row.status == '1'
                  ? 'success'
                  : 'danger'
              "
            >
              {{
                scope.row.status == "0"
                  ? "审查中"
                  : scope.row.status == "1"
                  ? "通过"
                  : "驳回"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          width="110"
        >
        </el-table-column>
        <el-table-column
          property="start_time"
          label="本周开始时间"
          align="center"
          sortable
          width="130"
        >
        </el-table-column>
        <el-table-column
          property="end_time"
          label="本周结束时间"
          align="center"
          sortable
          width="130"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="110">
          <template slot-scope="scope">
            <div class="control_box">
              <div
                @click="handleReject(scope.row)"
                class="writer_week_btn"
                :class="[
                  {
                    writer_day_btn: scope.row.status == -1,
                    disabled_btn: scope.row.status == 1 || scope.row.status == 0
                  }
                ]"
              >
                <i class="iconfont icon-jujue"></i>
                驳回查看
              </div>
              <el-upload
                class="upload-demo upload_btn"
                :action="uploadUrl"
                multiple
                :disabled="showUpload"
                :on-success="uploadFile"
                :show-file-list="false"
              >
                <div
                  class="writer_week_btn"
                  @click="editSubmit(scope.row)"
                  :class="[
                    {
                      writer_day_btn: scope.row.status == -1,
                      disabled_btn:
                        scope.row.status == 1 || scope.row.status == 0
                    }
                  ]"
                >
                  <i class="iconfont icon-kaohe1"></i>
                  修改提交
                </div>
              </el-upload>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 驳回弹窗 -->
    <el-dialog
      title="驳回"
      :visible.sync="rejectDialogVisible"
      width="90%"
      center
    >
      <div class="reject_dialog_box">
        <div class="reject_dialog_title">驳回原因：</div>
        <div class="reject_dialog_content">{{ rejectTxt }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog_btn"
          round
          type="primary"
          @click="rejectDialogVisible = false"
          >确认驳回</el-button
        >
        <el-button class="dialog_btn" round @click="rejectDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  connectionrecord_week_list,
  connectionrecord_week_suggestions,
  reject_file_operate
} from "@/utils/writer";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl, //路径
      writerId: "", //所属写手部id
      weekRecordList: [], //日结登记列表
      isFilterForm: true, //筛选表单
      rejectDialogVisible: false, //驳回弹窗

      timeData: [], //时间筛选
      filterTime: "", //筛选时间
      day_start: "", //开始时间
      day_end: "", //结束时间
      // 筛选
      filter_form: {
        connectionessay_name: "", //书名
        writer_nickname: "", //写手昵称
        writer_name: "", //写手姓名
        alipay_account: "", //写手支付宝
        is_settle: "", //日结状态
        status: "" //是否通过 0=审查中，1=通过，-1=驳回
      },
      rejectTxt: "", //驳回原因
      connectionessay_id: "", //文件上传id
      showUpload: false, //弹窗是否显示
      connectionrecord_id: "" //文章id
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getDayRecordList();
  },
  methods: {
    // 获取写手日结登记列表
    getDayRecordList(time, filter) {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        createtime: time,
        page: 1,
        page_index: 10,
        ...filter
      };
      connectionrecord_week_list(obj).then(res => {
        if (res.data.code == 1) {
          that.weekRecordList = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 文件上传
    uploadFile(val) {
      var that = this;

      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: that.connectionessay_id,
        file: val.data.url,
        connectionrecord_id: that.connectionrecord_id
      };
      reject_file_operate(obj).then(res => {
        if (res.data.code == 1) {
          that.getDayRecordList(that.filterTime, that.filter_form);
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 提交修改
    editSubmit(val) {
      var that = this;
      var current_status = val.status;
      if (current_status == -1) {
        that.showUpload = false;
        that.connectionessay_id = val.connectionessay_id;
        that.connectionrecord_id = val.id;
        this.$message("只能上传doc、docx文件");
      } else if (current_status == 0) {
        that.showUpload = true;
        this.$message.error("审查中,无法修改");
        return false;
      } else {
        that.showUpload = true;
        this.$message.error("已通过,无法修改");
        return false;
      }
    },
    // 筛选
    goSearch() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10,
        createtime: that.filterTime,
        ...that.filter_form
      };
      connectionrecord_week_list(obj).then(res => {
        if (res.data.code == 1) {
          that.weekRecordList = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 时间段筛选
    timeChange(val) {
      var that = this;
      that.day_start = val[0];
      that.day_end = val[1];
      that.filterTime = that.day_start + " - " + that.day_end;
      that.goSearch();
    },
    // 驳回弹窗
    handleReject(val) {
      var that = this;
      that.rejectDialogVisible = true;
      let obj = {
        departmentuser_id: that.writerId,
        connectionrecord_id: val.id
      };
      connectionrecord_week_suggestions(obj).then(res => {
        if (res.data.code == 1) {
          that.rejectTxt = res.data.data;
          that.getDayRecordList(that.filterTime, that.filter_form);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.week_record_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: #ffffff;
  border: 1px solid #e4e9f1;
}
.week_record_box .el-form-item {
  margin: 10px 0px;
}
.week_record_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;

  padding: 15px;
}
.task_box {
  margin: 0px 15px;
  margin-bottom: 150px;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
.writer_week_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  color: #157df8;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  margin-right: 5px;
  margin-bottom: 5px;
}
.writer_week_btn i {
  font-size: 12px;
}
.sea_icon {
  font-size: 12px;
}

.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  background: #ffffff;
  margin: 0px 15px;
  padding-top: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.control_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}
/* 驳回弹窗 */
.reject_dialog_box {
  width: 400px;
  display: flex;
  flex-direction: row;
  padding: 10px;
}
.reject_dialog_title {
  width: 150px;
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.reject_dialog_content {
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  padding: 0px 10px;
}
.week {
  background: #f9f1fc;
  color: #af50d7;
  border: none;
}
.day {
  background: #e3f9e9;
  color: #67c23a;
  border: none;
}
.disabled_btn {
  cursor: not-allowed;
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #eeeeee;
  color: #8893a7;
  border-radius: 10px;
  margin-right: 5px;
  font-size: 12px;
  /* pointer-events: none; */
}
.disabled_btn i {
  font-size: 12px;
}
</style>
<style>
@media screen and (max-width: 750px) and (min-width: 375px) {
  /* 移动端
  .el-picker-panel {
    width: 372px !important;
  }
  .el-date-range-picker .el-picker-panel__body {
    min-width: 373px !important;
  }
  .el-date-range-picker__content .el-date-range-picker__header div {
    margin-left: 0 !important;
    margin-right: 15px !important;
  }
  .el-input__inner {
    padding: 0px 3px !important;
  }
  .el-date-editor .el-range-input {
    width: 70% !important;
  } */
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterWeekRecordMobile.vue